import type { RootStateOrAny } from 'react-redux'

export const getSelectedRecipeVariants = (state: RootStateOrAny) =>
  state.menu.get('selectedRecipeVariants')
